const defaultState = {
  error: null,
  success: null,
  processing: false,
  options: [],
  current_page: 0,
  last_page: 1,
};

// Only servers that are up are selectable, matching the previous client-side
// `server?.status` filter.
function toOptions(rows) {
  return (rows || [])
    .filter((server) => server && !!server?.sites_count )
    .map((server) => ({ value: server.id, label: server.name }));
}

export default function getServerModulesDropdownReducer(
  state = defaultState,
  action
) {
  switch (action.type) {
    case "GET_SERVER_MODULES_DROPDOWN_SUCCESS": {
      let payload =
        (action.success &&
          action.success.data &&
          action.success.data.data) ||
        {};
      let fetched = toOptions(payload.data);
      let options = action.append
        ? state.options.concat(
            fetched.filter(
              (option) =>
                !state.options.some((loaded) => loaded.value === option.value)
            )
          )
        : fetched;

      return {
        ...state,
        success: action.success,
        options,
        current_page: payload.current_page || 1,
        last_page: payload.last_page || 1,
      };
    }

    case "GET_SERVER_MODULES_DROPDOWN_ERROR":
      return { ...state, error: action.error };

    case "GET_SERVER_MODULES_DROPDOWN_PROCESSING":
      return { ...state, processing: action.processing };

    case "GET_SERVER_MODULES_DROPDOWN_RESET":
      return { ...defaultState };

    default:
      return state;
  }
}
